// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard__customerViewCard .query_builder_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dashboard__customerViewCard .query_builder_row .query_builder_box {
  width: 50%;
}
.dashboard__customerViewCard .query_builder_row .query_builder_box .person {
  display: flex;
  justify-content: end;
  align-items: center;
}
.dashboard__customerViewCard .query_builder_row .query_builder_box .person p {
  margin-right: 1rem;
}
@media only screen and (max-width: 768px) {
  .dashboard__customerViewCard .query_builder_row {
    flex-wrap: wrap;
    margin-bottom: 1rem;
  }
  .dashboard__customerViewCard .query_builder_row .query_builder_box {
    width: 100%;
  }
}

.ruleGroup {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  border-color: #8081a2;
  border-style: solid;
  border-radius: 0.25rem;
  border-width: 1px;
  background: rgba(0, 75, 183, 0.2);
}
.ruleGroup .ruleGroup-body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.ruleGroup .ruleGroup-body:empty {
  display: none;
}
.ruleGroup .ruleGroup-header,
.ruleGroup .rule {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.ruleGroup .rule .rule-value:has(.rule-value-list-item) {
  display: flex;
  gap: 0.5rem;
  align-items: baseline;
}

[data-inlinecombinators=disabled] .dndOver.rule, [data-inlinecombinators=disabled] .dndOver.ruleGroup-header {
  border-bottom-width: 2px;
  border-bottom-style: dashed;
  border-bottom-color: rebeccapurple;
  padding-bottom: 0.5rem;
}
[data-inlinecombinators=disabled] .dndOver.rule.dndCopy, [data-inlinecombinators=disabled] .dndOver.ruleGroup-header.dndCopy {
  border-bottom-color: #669933;
}

[data-inlinecombinators=enabled] .dndOver.rule:last-child, [data-inlinecombinators=enabled] .dndOver.ruleGroup-header, [data-inlinecombinators=enabled] .dndOver.rule + .betweenRules, [data-inlinecombinators=enabled] .dndOver.betweenRules {
  border-bottom-width: 2px;
  border-bottom-style: dashed;
  border-bottom-color: rebeccapurple;
  padding-bottom: 0.5rem;
}
[data-inlinecombinators=enabled] .dndOver.rule:last-child.dndCopy, [data-inlinecombinators=enabled] .dndOver.ruleGroup-header.dndCopy, [data-inlinecombinators=enabled] .dndOver.rule + .betweenRules.dndCopy, [data-inlinecombinators=enabled] .dndOver.betweenRules.dndCopy {
  border-bottom-color: #669933;
}

.ruleGroup.dndDragging,
.rule.dndDragging {
  opacity: 0.5;
}
.ruleGroup .queryBuilder-dragHandle,
.rule .queryBuilder-dragHandle {
  cursor: move;
}

.queryBuilder-branches .ruleGroup-body {
  margin-left: calc(2 * 0.5rem);
}
.queryBuilder-branches .rule,
.queryBuilder-branches .ruleGroup .ruleGroup {
  position: relative;
}
.queryBuilder-branches .rule::before, .queryBuilder-branches .rule::after,
.queryBuilder-branches .ruleGroup .ruleGroup::before,
.queryBuilder-branches .ruleGroup .ruleGroup::after {
  content: "";
  width: 0.5rem;
  left: calc(-0.5rem - 1px);
  border-color: #8081a2;
  border-style: solid;
  border-radius: 0;
  position: absolute;
}
.queryBuilder-branches .rule::before,
.queryBuilder-branches .ruleGroup .ruleGroup::before {
  top: -0.5rem;
  height: calc(50% + 0.5rem);
  border-width: 0 0 1px 1px;
}
.queryBuilder-branches .rule:last-child::before,
.queryBuilder-branches .ruleGroup .ruleGroup:last-child::before {
  border-bottom-left-radius: 0.25rem;
}
.queryBuilder-branches .rule::after,
.queryBuilder-branches .ruleGroup .ruleGroup::after {
  top: 50%;
  height: 50%;
  border-width: 0 0 0 1px;
}
.queryBuilder-branches .rule:last-child::after,
.queryBuilder-branches .ruleGroup .ruleGroup:last-child::after {
  display: none;
}
.queryBuilder-branches .ruleGroup .ruleGroup::before, .queryBuilder-branches .ruleGroup .ruleGroup::after {
  left: calc(-0.5rem - 1px - 1px);
}
.queryBuilder-branches .ruleGroup .ruleGroup::before {
  top: calc(-0.5rem - 1px);
  height: calc(50% + 0.5rem + 1px);
}
.queryBuilder-branches .ruleGroup .ruleGroup::after {
  height: calc(50% + 1px);
}
.queryBuilder-branches .betweenRules {
  position: relative;
}
.queryBuilder-branches .betweenRules::before {
  content: "";
  width: 0.5rem;
  left: calc(-0.5rem - 1px);
  border-color: #8081a2;
  border-style: solid;
  border-radius: 0;
  position: absolute;
  top: -0.5rem;
  height: calc(100% + 0.5rem);
  border-width: 0 0 0 1px;
}

.queryBuilder .ant-input {
  width: auto;
}
.queryBuilder .ant-btn.css-dev-only-do-not-override-nllxry.ant-btn-primary.ruleGroup-addGroup span::after {
  content: " Rule";
}
.queryBuilder select, .queryBuilder input {
  padding: 4px 10px;
  border: 1px solid #282828;
  border-radius: 4px;
}
.queryBuilder button {
  padding: 4px 10px;
  background-color: #d9eeff;
  color: #282828;
  border: 1px solid #282828;
  border-radius: 4px;
  font-weight: 700;
}

@media only screen and (max-width: 600px) {
  .ruleGroup .ruleGroup-header, .ruleGroup .rule {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/query_builder.scss","webpack://./node_modules/react-querybuilder/dist/query-builder.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAAR;AAEQ;EACI,UAAA;AAAZ;AAEY;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;AAAhB;AAEgB;EACI,kBAAA;AAApB;AAKQ;EAnBJ;IAoBQ,eAAA;IACA,mBAAA;EAFV;EAIU;IACI,WAAA;EAFd;AACF;;ACFA;EACE,aAAA;EACA,sBAAA;EACA,WAxBY;EAyBZ,eAzBY;EA0BZ,qBAxBiB;EAyBjB,mBAxBiB;EAyBjB,sBAxBkB;EAyBlB,iBAxBiB;EAyBjB,iCA7BqB;ADkCvB;ACHE;EACE,aAAA;EACA,sBAAA;EACA,WAnCU;ADwCd;ACHI;EACE,aAAA;ADKN;ACDE;;EAEE,aAAA;EACA,WA7CU;EA8CV,mBAAA;ADGJ;ACCI;EACE,aAAA;EACA,WApDQ;EAqDR,qBAAA;ADCN;;ACSI;EAEE,wBAtD8B;EAuD9B,2BAxD8B;EAyD9B,kCA3D8B;EA4D9B,sBApEQ;AD6Dd;ACSM;EACE,4BA9DiC;ADuDzC;;ACcI;EAIE,wBAvE8B;EAwE9B,2BAzE8B;EA0E9B,kCA5E8B;EA6E9B,sBArFQ;ADuEd;ACgBM;EACE,4BA/EiC;ADiEzC;;ACuBE;;EACE,YAAA;ADnBJ;ACsBE;;EACE,YAAA;ADnBJ;;AC0BE;EACE,6BAAA;ADvBJ;AC0BE;;EAEE,kBAAA;ADxBJ;AC0BI;;;EAEE,WAAA;EACA,aAxHQ;EAyHR,yBAAA;EACA,qBAxHa;EAyHb,mBAxHa;EAyHb,gBAAA;EACA,kBAAA;ADvBN;AC0BI;;EACE,YAAA;EACA,0BAAA;EACA,yBAAA;ADvBN;AC0BI;;EACE,kCAnIc;AD4GpB;AC0BI;;EACE,QAAA;EACA,WAAA;EACA,uBAAA;ADvBN;AC0BI;;EACE,aAAA;ADvBN;AC4BI;EAEE,+BAAA;AD3BN;AC8BI;EACE,wBAAA;EACA,gCAAA;AD5BN;AC+BI;EACE,uBAAA;AD7BN;ACiCE;EACE,kBAAA;AD/BJ;ACiCI;EACE,WAAA;EACA,aA1KQ;EA2KR,yBAAA;EACA,qBA1Ka;EA2Kb,mBA1Ka;EA2Kb,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,uBAAA;AD/BN;;AA/GI;EACI,WAAA;AAkHR;AAhHI;EACI,gBAAA;AAkHR;AAhHI;EACI,iBAAA;EACA,yBAAA;EACA,kBAAA;AAkHR;AAhHI;EACI,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAkHR;;AA7GA;EACI;IACI,eAAA;EAgHN;AACF","sourcesContent":[".dashboard__customerViewCard{\r\n    .query_builder_row{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n\r\n        .query_builder_box{\r\n            width: 50%;\r\n\r\n            .person{\r\n                display: flex;\r\n                justify-content: end;\r\n                align-items: center;\r\n\r\n                p{\r\n                    margin-right: 1rem;\r\n                }\r\n            }\r\n        }\r\n\r\n        @media only screen and (max-width: 768px){\r\n            flex-wrap: wrap;\r\n            margin-bottom: 1rem;\r\n\r\n            .query_builder_box{\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@import 'react-querybuilder/dist/query-builder.scss';\r\n\r\n\r\n\r\n  \r\n.queryBuilder {\r\n    .ant-input {\r\n        width: auto;\r\n    }\r\n    .ant-btn.css-dev-only-do-not-override-nllxry.ant-btn-primary.ruleGroup-addGroup span::after {\r\n        content: \" Rule\";\r\n    }\r\n    select,input{\r\n        padding: 4px 10px;\r\n        border: 1px solid #282828;\r\n        border-radius: 4px;\r\n    }\r\n    button{\r\n        padding: 4px 10px;\r\n        background-color: #d9eeff;\r\n        color: #282828;\r\n        border: 1px solid #282828;\r\n        border-radius: 4px;\r\n        font-weight: 700;\r\n    }\r\n\r\n}\r\n\r\n@media only screen and (max-width: 600px){\r\n    .ruleGroup .ruleGroup-header, .ruleGroup .rule{\r\n        flex-wrap: wrap;\r\n    }\r\n}\r\n\r\n\r\n","// Basic\n$rqb-spacing: 0.5rem !default;\n$rqb-background-color: rgba(0, 75, 183, 0.2) !default;\n$rqb-border-color: #8081a2 !default;\n$rqb-border-style: solid !default;\n$rqb-border-radius: 0.25rem !default;\n$rqb-border-width: 1px !default;\n\n// Drag-and-drop\n$rqb-dnd-hover-border-bottom-color: rebeccapurple !default;\n$rqb-dnd-hover-copy-border-bottom-color: #669933 !default;\n$rqb-dnd-hover-border-bottom-style: dashed !default;\n$rqb-dnd-hover-border-bottom-width: 2px !default;\n\n// Branches\n$rqb-branch-indent: $rqb-spacing !default;\n$rqb-branch-color: $rqb-border-color !default;\n$rqb-branch-width: $rqb-border-width !default;\n$rqb-branch-radius: $rqb-border-radius !default;\n$rqb-branch-style: $rqb-border-style !default;\n\n// Default styles\n.ruleGroup {\n  display: flex;\n  flex-direction: column;\n  gap: $rqb-spacing;\n  padding: $rqb-spacing;\n  border-color: $rqb-border-color;\n  border-style: $rqb-border-style;\n  border-radius: $rqb-border-radius;\n  border-width: $rqb-border-width;\n  background: $rqb-background-color;\n\n  .ruleGroup-body {\n    display: flex;\n    flex-direction: column;\n    gap: $rqb-spacing;\n\n    &:empty {\n      display: none;\n    }\n  }\n\n  .ruleGroup-header,\n  .rule {\n    display: flex;\n    gap: $rqb-spacing;\n    align-items: center;\n  }\n\n  .rule {\n    .rule-value:has(.rule-value-list-item) {\n      display: flex;\n      gap: $rqb-spacing;\n      align-items: baseline;\n    }\n  }\n}\n\n// #region Drag-and-drop\n\n// Hover styles\n[data-inlinecombinators='disabled'] {\n  .dndOver {\n    &.rule,\n    &.ruleGroup-header {\n      border-bottom-width: $rqb-dnd-hover-border-bottom-width;\n      border-bottom-style: $rqb-dnd-hover-border-bottom-style;\n      border-bottom-color: $rqb-dnd-hover-border-bottom-color;\n      padding-bottom: $rqb-spacing;\n\n      &.dndCopy {\n        border-bottom-color: $rqb-dnd-hover-copy-border-bottom-color;\n      }\n    }\n  }\n}\n[data-inlinecombinators='enabled'] {\n  .dndOver {\n    &.rule:last-child,\n    &.ruleGroup-header,\n    &.rule + .betweenRules,\n    &.betweenRules {\n      border-bottom-width: $rqb-dnd-hover-border-bottom-width;\n      border-bottom-style: $rqb-dnd-hover-border-bottom-style;\n      border-bottom-color: $rqb-dnd-hover-border-bottom-color;\n      padding-bottom: $rqb-spacing;\n\n      &.dndCopy {\n        border-bottom-color: $rqb-dnd-hover-copy-border-bottom-color;\n      }\n    }\n  }\n}\n\n// Drag styles\n.ruleGroup,\n.rule {\n  &.dndDragging {\n    opacity: 0.5;\n  }\n\n  .queryBuilder-dragHandle {\n    cursor: move;\n  }\n}\n// #endregion\n\n// #region Branches\n.queryBuilder-branches {\n  .ruleGroup-body {\n    margin-left: calc(2 * #{$rqb-branch-indent});\n  }\n\n  .rule,\n  .ruleGroup .ruleGroup {\n    position: relative;\n\n    &::before,\n    &::after {\n      content: '';\n      width: $rqb-branch-indent;\n      left: calc(-#{$rqb-branch-indent} - #{$rqb-branch-width});\n      border-color: $rqb-branch-color;\n      border-style: $rqb-branch-style;\n      border-radius: 0;\n      position: absolute;\n    }\n\n    &::before {\n      top: -$rqb-spacing;\n      height: calc(50% + #{$rqb-spacing});\n      border-width: 0 0 $rqb-branch-width $rqb-branch-width;\n    }\n\n    &:last-child::before {\n      border-bottom-left-radius: $rqb-branch-radius;\n    }\n\n    &::after {\n      top: 50%;\n      height: 50%;\n      border-width: 0 0 0 $rqb-branch-width;\n    }\n\n    &:last-child::after {\n      display: none;\n    }\n  }\n\n  .ruleGroup .ruleGroup {\n    &::before,\n    &::after {\n      left: calc(calc(-#{$rqb-branch-indent} - #{$rqb-branch-width}) - #{$rqb-border-width});\n    }\n\n    &::before {\n      top: calc(-#{$rqb-spacing} - #{$rqb-border-width});\n      height: calc(50% + #{$rqb-spacing} + #{$rqb-border-width});\n    }\n\n    &::after {\n      height: calc(50% + #{$rqb-border-width});\n    }\n  }\n\n  .betweenRules {\n    position: relative;\n\n    &::before {\n      content: '';\n      width: $rqb-branch-indent;\n      left: calc(-#{$rqb-branch-indent} - #{$rqb-branch-width});\n      border-color: $rqb-branch-color;\n      border-style: $rqb-branch-style;\n      border-radius: 0;\n      position: absolute;\n      top: -$rqb-spacing;\n      height: calc(100% + #{$rqb-spacing});\n      border-width: 0 0 0 $rqb-branch-width;\n    }\n  }\n}\n// #endregion\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
